import correctImage from "../pages/Otp/correct.png";
import failedImge from "../pages/Otp/failed.png";
import loadingImage from "../pages/Otp/load-icon.png";

//AVCDAAV.002  22/03/2025  Add code for Adding config path for image
export const imageList = {
    correct_image: correctImage,
    failed_image: failedImge,
    loading_image: loadingImage
}
//C-AVCDAAV.002  22/03/2025  Add code for Adding config path for image